import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { PhoneNumber, VerifyPhoneNumber } from "components/signup/forms";

const OtpLogin = ({
  targetPath,
  onSuccess,
  changeMobileNumber,
  nig,
  nigData,
  isMerchant,
  switchMode,
  baseInfo,
  twoModeActive,
  buttonText,
  loginFromQr,
}) => {
  const [status, setStatus] = useState(); //verify | phone
  const [user, setUser] = useState({});
  const [selectedCountryCode, setSelectedCountryCodde] = useState("+98");
  const router = useRouter();
  useEffect(() => {
    console.log("OTPLogin");
    if (router.query.status === "verifyPhone") {
      setStatus("verify");
    } else {
      setStatus("phone");
    }
  }, [router.query.status]);

  return (
    <>
      {status === "phone" && (
        <PhoneNumber
          btnTitle={buttonText}
          changeState={(contryCode) => {
            setSelectedCountryCodde(contryCode);
            setStatus("verify");
          }}
          onSuccess={(id) => {
            setUser((prevState) => ({
              ...prevState,
              phoneNumber: id,
            }));
          }}
          switchMode={switchMode}
          baseInfo={baseInfo}
          twoModeActive={twoModeActive}
        />
      )}
      {status === "verify" && (
        <VerifyPhoneNumber
          user={user}
          changeState={() => {
            setStatus("phone");
            // router.query = "";
            router.push(window?.location?.pathname);
          }}
          targetPath={targetPath}
          onSuccess={onSuccess}
          changeMobileNumber={changeMobileNumber}
          nig={nig}
          nigData={nigData}
          isMerchant={isMerchant}
          contryCode={selectedCountryCode}
          loginFromQr={loginFromQr}
        />
      )}
    </>
  );
};

export default OtpLogin;
